import { memo } from 'react'
import { Link, useLocation } from 'react-router'

import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

import { SidebarItem, SidebarThemes } from '../types'

interface SidebarSimpleItemProps {
  item: SidebarItem
  isSidebarOpen: boolean
  theme?: SidebarThemes
}

export const SidebarSimpleItem = memo<SidebarSimpleItemProps>(
  ({ item, isSidebarOpen, theme = 'light' }: SidebarSimpleItemProps) => {
    const { icon, title, path } = item
    const { pathname } = useLocation()

    const isActive = path.includes(pathname)

    return (
      <li className="flex">
        <Tooltip delayDuration={200}>
          <TooltipTrigger
            className={cn(
              'mx-4 flex-1 rounded-2xl',
              isSidebarOpen ? 'justify-normal' : 'justify-center',
              isActive
                ? theme === 'dark'
                  ? 'bg-sidebar-primary-hover font-medium'
                  : 'bg-accent font-medium'
                : '',
            )}
            asChild
          >
            <Button
              variant={theme === 'dark' ? 'botEnvironment' : 'ghost'}
              size="sm"
              asChild
              className={cn(
                'w-full',
                isActive && '[&_svg]:[stroke-width:1.75]',
              )}
            >
              <Link to={path} className="flex w-full items-center">
                <span
                  className={cn(
                    theme === 'dark' ? 'text-white' : 'text-gray-500',
                  )}
                >
                  {icon}
                </span>
                {isSidebarOpen && (
                  <span key="sidebar-title" className="ml-2 overflow-hidden">
                    {title}
                  </span>
                )}
              </Link>
            </Button>
          </TooltipTrigger>

          <TooltipContent
            side="right"
            className={isSidebarOpen ? 'hidden' : 'text-sm'}
          >
            {title}
          </TooltipContent>
        </Tooltip>
      </li>
    )
  },
)

SidebarSimpleItem.displayName = 'SidebarSimpleItem'
